import { useState } from "react";

import { useTranslation } from 'react-i18next';

import Swal from 'sweetalert2';
import axios from 'axios';


const FormularioContacto = ({ lang, config }) => {

    const { t } = useTranslation();

    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [email, setEmail] = useState('');
    const [tema, setTema] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [consentimiento, setConsentimiento] = useState(false);

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = "/enviacontacto";

        var mensajeerror = "";

        if (nombre.trim() === "" || telefono.trim() === "" || email.trim() === "" || mensaje.trim() === "" || tema.trim() === "" || !consentimiento) {

            if (nombre.trim() === "") mensajeerror += `${t("Nombre")}<br/>`;
            if (telefono.trim() === "") mensajeerror += `${t('Teléfono')}<br/>`;
            if (email.trim() === "") mensajeerror += `${t('Email')}<br/>`;
            if (mensaje.trim() === "") mensajeerror += `${t('Mensaje')}<br/>`;
            if (tema.trim() === "") mensajeerror += `${t('Tema')}<br/>`;
            if (!consentimiento) mensajeerror += `${t("consentimiento")}<br/>`;

            Swal.fire({
                title: `${t('Error')}`,
                html: `${t('Todos los campos obligatorios')}<br/>` + mensajeerror,
                timer: 2500,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeClick: false
            });
        } else {
            let elnombre = nombre;
            let eltelefono = telefono;
            let elmail = email;
            let elmensaje = mensaje;
            let eltema = tema;
            let elidioma = document.getElementById("idioma").value;

            let token = document.getElementById('meta_token').getAttribute('content');
            const result = axios.post(url, {
                yourname: elnombre,
                Phone: eltelefono,
                contactEmail: elmail,
                contactMessage: eltema + "<br/>" + elmensaje,

                lang: elidioma
            }, {
                headers: {
                    'content-type': 'text/json',
                    'X-CSRF-TOKEN': token
                }
            })
                .then((response) => {
                    console.log(response);
                    if (response.data.type === "error") {
                        Swal.fire({
                            title: "KO!",
                            html: `${t('Contacto no enviado')}`,
                            timer: 1500,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        });
                    } else {
                        Swal.fire({
                            title: "OK!",
                            html: `${t('Contacto enviado')}`,
                            timer: 1500,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                        }).then((result) => {
                            window.location.reload();
                        });
                    }
                });
        }
    };



    // Formulari de contacte amb el disseny de Camprodon (c-form): camps amb
    // l'etiqueta flotant i la línia bordeus a sota.
    return (
        <div className="hc">
            <section id="contact-form-section" className="c-form bg-very-light-gray">
                <div className="o-container">
                    <div className="c-form--title">{t("Contacte_con_nosotros")}</div>
                    <div className="c-form--content">{t("Nos encanta que nos digan algo. Póngase en contacto con nosotros.")}</div>
                    <form className="c-form__form" id="contactForm" onSubmit={handleSubmit}>
                        <input type="hidden" name="lang" id="idioma" value={lang.toString().toUpperCase()} />
                        <div className="c-form__inputs">
                            <div className="c-form--element c-form--input">
                                <input className="c-input" type="text" id="contacte-nom" name="yourname" placeholder=" " value={nombre} onChange={(e) => setNombre(e.target.value)} />
                                <label className="c-label" htmlFor="contacte-nom">{t("Nombre")}</label>
                            </div>
                            <div className="c-form--element c-form--input">
                                <input className="c-input" type="email" id="contacte-email" name="contactEmail" placeholder=" " value={email} onChange={(e) => setEmail(e.target.value)} />
                                <label className="c-label" htmlFor="contacte-email">{t("Correo electrónico")}</label>
                            </div>
                            <div className="c-form--element c-form--input">
                                <input className="c-input" type="text" id="contacte-tema" name="subject" placeholder=" " value={tema} onChange={(e) => setTema(e.target.value)} />
                                <label className="c-label" htmlFor="contacte-tema">{t("Tema")}</label>
                            </div>
                            <div className="c-form--element c-form--input">
                                <input className="c-input" type="text" id="contacte-telefon" name="Phone" placeholder=" " value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                <label className="c-label" htmlFor="contacte-telefon">{t("Teléfono")}</label>
                            </div>
                        </div>
                        <div className="c-form--element">
                            <label className="c-label" htmlFor="contacte-missatge">{t("Mensaje")}</label>
                            <textarea className="c-input" id="contacte-missatge" name="contactMessage" rows="9" value={mensaje} onChange={(e) => setMensaje(e.target.value)}></textarea>
                        </div>
                        <div className="c-form__footer d-inline-flex-md">
                            <div>
                                <div className="c-checkbox">
                                    <input type="checkbox" id="contacte-acepto" name="acepto" value="acepto" checked={consentimiento} onChange={(e) => setConsentimiento(e.target.checked)} />
                                    <label htmlFor="contacte-acepto">
                                        <div className="c-checkbox__square"></div>
                                        <span><a href={"/" + preidioma + t("terminos")} target="_blank">{t("Acepto los términos y condiciones")}</a></span>
                                    </label>
                                </div>
                            </div>
                            <input type="submit" className="c-button c-button--outline c-button--full c-form--submit c-form--element" value={t("Enviar")} />
                        </div>
                    </form>
                </div>
            </section>
        </div>
    );
}

export default FormularioContacto;
